<template>

    <div>

        <div class="vld-parent">

            <!-- BEGIN HOVER PREVIEW TRIGGER -->
            <div class="absolute w-full cursor-pointer" style="height: 135px; z-index: 99;" @mouseenter="startVideoPreview" @mouseleave="endVideoPreview" @click="openPlayer"></div>
            <!-- END HOVER PREVIEW TRIGGER -->

            <loading :active="componentLoading" :is-full-page="false" :can-cancel="true"></loading>

            <div v-if="visibleOnHover" class="absolute z-10 w-full rounded-t-lg cursor-pointer overflow-hidden">

                <preview-video-player :videoSource="videoSource" :is_legacy="content.legacy"></preview-video-player>

            </div>


            <div class="relative desktop-item shadow cursor-pointer" @click="openPlayer">

                <img :src="image" alt="" height="135" style="object-fit: cover;" @error="setDefaultThumb" @load="loadingFinished" ref="thumbnailImage" />

                <div v-if="triggeringPreview" class="absolute w-full">
                    <progress-bar size="small"
                                  :val="hoverProgress"
                    ></progress-bar>
                </div>

                <p class="text-theme-main hover:text-theme-title pl-4 pr-4 pt-6 pb-4 leading-tight font-bold bg-theme-level4" v-text="title" style="max-height: 88px;"></p>

                <div class="flex-1 bg-theme-level4"></div>

                <span class="px-4 pb-4 pt-2 text-xs text-theme-discrete flex flex-row items-center bg-theme-level4">
                                <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                                <span class="flex-1"><span v-text="date"></span>, <span v-text="time"></span></span>
                                <i id="module-options-button"
                                   class="relative material-icons cursor-pointer text-theme-muted hover:text-theme-discrete hover:bg-theme-level3 rounded-full"
                                   style="font-size: 26px;right: -10px;"
                                   @click.stop="showContextMenu"
                                   @mouseleave="hideContextMenu"
                                >more_vert</i>
                            </span>

                <div id="media-duration"
                     class="absolute bg-theme-dropdowndismissal w-32 h-8
                                        text-theme-control-label text-center pt-2 opacity-75
                                        border border-theme-control-label rounded-md"
                     style="top: 30%; right: 12px; z-index: 10;" v-text="duration"></div>

                    <!--<div v-if="true" id="context-menu"-->
                    <div v-if="contextMenuVisible" id="context-menu"
                         class="absolute p-4 w-48 bg-theme-level4 text-sm rounded-lg border border-theme-level1 shadow-xl"
                         style="bottom: 6px; right: 20px; z-index: 100;"
                         @mouseenter="showContextMenu"
                         @mouseleave="hideContextMenu"
                    >
                        <ul>
                            <li v-if="userAuthenticated" @click.stop="addToPlaylist" class="text-theme-muted hover:text-theme-title cursor-pointer" style="margin-bottom: 0.75rem;">{{ translate('playlist-add') }}</li>

                            <li v-if="userAuthenticated" @click.stop="addToWatchLater" class="text-theme-muted hover:text-theme-title cursor-pointer" style="margin-bottom: 0.75rem;">{{ translate('playlist-watch-later') }}</li>

                            <li @click.stop="getEmbedCode" class="text-theme-muted hover:text-theme-title cursor-pointer" style="margin-bottom: 0.75rem;">{{ translate('embed-code') }}</li>

                            <li @click.stop="getShareableLink" class="text-theme-muted hover:text-theme-title cursor-pointer" style="margin-bottom: 0.75rem;">{{ translate('share-link-label') }}</li>

                            <li v-if="downloadable" @click.stop="downloadContent" class="text-theme-muted hover:text-theme-title cursor-pointer" style="margin-bottom: 0.75rem;">{{ translate('download-content') }}</li>

                            <li @click.stop="" class="text-theme-muted hover:text-theme-title cursor-pointer" style="margin-bottom: 0.75rem;">
                                <ShareNetwork
                                    network="facebook"
                                    :url="shareableLinkCode"
                                    :title="title"
                                    :description="abstract"
                                >
                                    {{ translate('share-facebook') }}
                                </ShareNetwork>
                            </li>
                            <li @click.stop="" class="text-theme-muted hover:text-theme-title cursor-pointer" style="margin-bottom: 0.75rem;">
                                <ShareNetwork
                                    network="twitter"
                                    :url="shareableLinkCode"
                                    :title="title"
                                    hashtags="telesurtv"
                                    twitter-user="telesurtv"
                                >
                                    {{ translate('share-twitter') }}
                                </ShareNetwork>
                            </li>
                            <li @click.stop="" class="text-theme-muted hover:text-theme-title cursor-pointer">
                                <ShareNetwork
                                    network="whatsapp"
                                    :url="shareableLinkCode"
                                    :title="title"
                                    :description="abstract"
                                >
                                    {{ translate('share-whatsapp') }}
                                </ShareNetwork>
                            </li>

                            <li v-if="userAuthenticated && ((userRole === 'superadmin') || (userRole === 'admin') || (userRole === 'author'))"
                                @click.stop="editContent" class="text-red-300 hover:text-red-500 cursor-pointer" style="margin-top: 0.75rem;">
                                <span>{{ translate('content-edit-in-module') }}</span>
                            </li>

                        </ul>
                    </div>

            </div>


        </div>

        <div v-if="embedCodePanelVisible" class="fixed w-full h-full flex flex-col items-center justify-center" style="background-color: rgba(0,0,0,0.75); top: 0; left: 0; z-index: 9999;">
            <div class="bg-theme-level3 rounded-lg shadow-2xl p-6 flex flex-col" style="width: 38rem; height: 22rem;">
                <span class="text-base text-theme-main font-bold mb-4">{{ translate('embed-code-title') }}</span>
                <span class="text-sm text-theme-discrete font-bold mb-6">{{ translate('embed-code-description') }}</span>
                <div class="text-sm text-theme-discrete mb-6">
                    <pre style="white-space: pre-wrap;"><code>{{ embedCode }}</code></pre>
                </div>
                <div class="flex flex-row items-center justify-center">
                    <button class="flex flex-row items-center justify-center text-base hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                            :class="{'bg-theme-controls3': !embedCodeWasCopied && !embedCodeHadError, 'bg-green-500 hover:bg-green-500': embedCodeWasCopied, 'bg-red-500 hover:bg-red-500': embedCodeHadError}"
                            @click.stop="copyEmbedCodeToClipboard">
                        {{ copy_label }}
                    </button>
                    <button class="ml-2 flex flex-row items-center justify-center text-base bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                            @click="embedCodePanelVisible=false">
                        {{ translate('close') }}
                    </button>
                </div>
            </div>
        </div>

        <div v-if="shareableLinkPanelVisible" class="fixed w-full h-full flex flex-col items-center justify-center" style="background-color: rgba(0,0,0,0.75); top: 0; left: 0; z-index: 9999;">
            <div class="bg-theme-level3 rounded-lg shadow-2xl p-6 flex flex-col" style="width: 38rem; height: 16rem;">
                <span class="text-base text-theme-main font-bold mb-4">{{  translate('share-link-title') }}</span>
                <span class="text-sm text-theme-discrete font-bold mb-10">{{ translate('share-link-description') }}</span>
                <div class="text-sm text-theme-discrete mb-12">
                    <code>{{ shareableLinkCode }}</code>
                </div>
                <div class="flex flex-row items-center justify-center">
                    <button class="flex flex-row items-center justify-center text-base hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                            :class="{'bg-theme-controls3': !shareableLinkWasCopied && !shareableLinkHadError, 'bg-green-500 hover:bg-green-500': shareableLinkWasCopied, 'bg-red-500 hover:bg-red-500': shareableLinkHadError}"
                            @click.stop="copyLinkToClipboard">
                        {{ copy_label }}
                    </button>
                    <button class="ml-2 flex flex-row items-center justify-center text-base bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                            @click.stop="shareableLinkPanelVisible=false">
                        {{ translate('close') }}
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import ProgressBar from 'vue-simple-progress';

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        components: {
            Loading,
            ProgressBar
        },

        data() {
            return {
                componentLoading: true,
                contentId: this.content.id,

                title: this.content.title,
                abstract: this.content.abstract,
                date: (this.content.publish_date).split(' ')[0],
                time: (this.content.publish_date).split(' ')[1],
                duration: this.content.media_duration,

                contextMenuVisible: false,
                embedCodePanelVisible: false,
                shareableLinkPanelVisible: false,

                copy_label: this.translate('copy'),
                shareableLinkWasCopied: false,
                shareableLinkHadError: false,

                embedCodeWasCopied: false,
                embedCodeHadError: false,

                visibleOnHover: false,

                ENV_CloudFront_Legacy_DNS_Name: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_DNS_Name: process.env.MIX_CLOUDFRONT_DNSNAME,

                timer: '',
                triggeringPreview: false,
                hoverProgress: 0
            }
        },

        computed: {

            userAuthenticated() {
                return window.Laravel.user
            },

            userRole() {

                return window.Laravel.userRole

            },

            embedCode() {

                let tmp = '<div>\n' +
                    '  <div style="position:relative;overflow:hidden; padding-bottom:58%;height:100%;">\n' +
                    '    <iframe src="https://' +
                    window.location.hostname + '/embed/' + this.legacy + '/' + this.contentId +
                    '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen style="position:absolute;width:100%;height:100%;top:0;left:0;">\n' +
                    '    </iframe>\n' +
                    '  </div>\n' +
                    '</div>'

                return tmp;
            },

            shareableLinkCode() {

                return 'https://' + window.location.hostname + '/' + this.currentlocale + '/content/' + this.contentId;

            },

            downloadable() {

                return this.content.restrictions === 'Abierto' || this.content.restrictions === 'Open';

            },

            image: {

                get: function () {
                    if (this.legacy) {
                        if (this.content.thumbnail_url !== '') {
                            return process.env.MIX_LEGACY_THUMBNAILS_CLOUDFRONT_DNSNAME + this.content.thumbnail_url;
                        } else {
                            return this.default_thumbnail
                        }
                    } else {
                        return process.env.MIX_CLOUDFRONT_DNSNAME + this.content.thumbnail_url;
                    }
                },

                set: function (newValue) {

                    return this.default_thumbnail

                }
            },

            playerOptions() {

                return {
                    autoplay: false,
                }

            },

            videoSource() {

                if(this.legacy) {
                    return this.ENV_CloudFront_Legacy_DNS_Name + this.content.storage_url;
                } else {
                    return this.ENV_CloudFront_DNS_Name + this.content.storage_url;
                }

            }

        },

        props: [
            'content',
            'currentlocale',
            'legacy',
            'default_thumbnail'
        ],

        methods: {

            editContent() {
                window.location='/' + this.currentlocale + '/admin/content/edit/' + this.contentId;
            },

            setDefaultThumb() {

                this.$refs.thumbnailImage.src = this.default_thumbnail

            },

            addToWatchLater() {

                axios.get('/' + this.currentlocale + '/watchlater/add/' + this.contentId)
                    .then((response) => {
                        if(response.data === 'added') {
                            this.flashMessage.success({
                                title: '',
                                message: this.translate('playlist-added') + ' ' + this.translate('playlist-watch-later'),
                                blockClass: 'p-6',
                                x: 25,
                                y: 150,
                                time: 3000
                            });
                        }
                        if(response.data === 'exists') {
                            this.flashMessage.warning({
                                title: '',
                                message: this.translate('playlist-already-added'),
                                blockClass: 'p-6',
                                x: 25,
                                y: 150,
                                time: 3000
                            });
                        }
                    })
                    .catch((error) => {
                        console.log('ERROR trying to add item to Watch Later List: ' + error)
                    })

            },

            addToPlaylist() {

                this.$root.shared.contentIdToAddToPlaylist = this.contentId
                this.$root.shared.playlistChooserVisible = true

            },

            startVideoPreview() {

                this.triggeringPreview = true

                this.timer = setInterval(
                    () => {
                        this.hoverProgress += 10
                        if(this.hoverProgress >= 130) {
                            clearInterval(this.timer)
                            this.triggeringPreview = false
                            this.hoverProgress = 0
                            this.visibleOnHover = true
                        }
                    }, 100);

            },

            endVideoPreview() {

                this.triggeringPreview = false
                this.visibleOnHover = false
                this.hoverProgress = 0
                clearInterval(this.timer)

            },

            loadingFinished() {
                this.componentLoading=false
            },

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            openPlayer() {

                // Before opening the player, and for several reasons, we will update the browser's
                // address bar with the content URL; before that, we will store the previous URL in order
                // to be able to restore it once the player view is closed
                this.$root.shared.previousPageURL = window.location.href
                document.title = this.content.title
                window.history.pushState({ "pageTitle": this.content.title }, this.content.title, '/' + this.currentlocale + '/content/' + this.content.id)

                // Now, we can move on:
                this.endVideoPreview()
                /*console.log('Firing up the player...');*/
                Event.fire('showPlayer', { language: this.currentlocale, data: this.content });
            },

            showContextMenu() {
                this.contextMenuVisible = true;
            },

            hideContextMenu() {
                this.contextMenuVisible = false;
            },

            getEmbedCode() {
                this.contextMenuVisible = false;
                this.embedCodePanelVisible = true;
            },

            downloadContent() {
                // alert(this.legacy);
                if(this.legacy) {
                    window.location=process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME + this.content.filename;
                } else {
                    window.location=process.env.MIX_CLOUDFRONT_DNSNAME + this.content.filename + '/' + this.content.filename + '.mp4';
                }
                /*window.location=process.env.MIX_CLOUDFRONT_DNSNAME + this.content.filename + '/' + this.content.filename + '.mp4';*/
            },

            getShareableLink() {
                this.shareableLinkPanelVisible=true;
            },

            setCopyLabelOk() {
                this.copy_label = this.translate('copied');
            },

            setCopyLabelError() {
                this.copy_label = 'Error!';
            },

            copyLinkToClipboard() {

                this.$copyText(this.shareableLinkCode).then((e) => {
                    this.setCopyLabelOk();
                    this.shareableLinkWasCopied=true;
                    console.log(e);
                }, (e) => {
                    this.setCopyLabelError();
                    this.shareableLinkHadError=true;
                    console.log(e)
                })
            },

            copyEmbedCodeToClipboard() {
                this.$copyText(this.embedCode).then((e) => {
                    this.setCopyLabelOk();
                    this.embedCodeWasCopied=true;
                    console.log(e);
                }, (e) => {
                    this.setCopyLabelError();
                    this.embedCodeHadError=true;
                    console.log(e)
                })
            }
        },

    }
</script>

<style scoped>

    img {
        width: 100%;
        height: 135px;
    }

    .desktop-hs > li,
    .desktop-item {
        scroll-snap-align: center;
        /*padding: calc(var(--gutter) / 2 * 1.5);*/
        display: flex;
        flex-direction: column;
        justify-content: start;
        /*align-items: center;*/
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        max-height: 280px;
        min-height: 280px;
    }

</style>
